import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import CustomFieldsSnippet from 'common/developers/docs/sdk/snippets/CustomFieldsSnippet';
import MultiLanguageCodeBlock from 'common/developers/docs/widget/MultiLanguageCodeBlock';
import CustomFieldsDocsHelmet from 'common/helmets/CustomFieldsDocsHelmet';
import withContexts from 'common/util/withContexts';

import 'css/components/developers/docs/install/_IdentifyDocs.scss';

class CompaniesDocs extends Component {
  static propTypes = {
    company: PropTypes.object,
    viewer: PropTypes.object,
  };

  renderCompanyPicker() {
    const { company, viewer } = this.props;
    if (company?._id) {
      return null;
    }

    if (!viewer || viewer.loggedOut) {
      return (
        <div className="description">
          <span className="bold">To find your appID</span>, log in above. You'll see your appID
          pre&#8209;filled in the code&nbsp;snippet.
        </div>
      );
    }
  }

  renderSnippet() {
    const { company } = this.props;
    if (!company?._id) {
      return CustomFieldsSnippet;
    }

    return CustomFieldsSnippet.replace('YOUR_APP_ID', company._id);
  }

  render() {
    return (
      <div className="identifyDocs">
        <CustomFieldsDocsHelmet />
        <div className="heading">Add Custom Fields</div>
        <div className="description">
          You can associate custom fields with both users and companies, via identify. Then in Canny
          you can segment by this data to dig even deeper into your user&nbsp;feedback&nbsp;data.
        </div>
        {this.renderCompanyPicker()}
        <MultiLanguageCodeBlock
          blocks={[
            {
              code: this.renderSnippet(),
              language: 'js',
            },
          ]}
          showSelector={false}
        />
      </div>
    );
  }
}

export default compose(
  withContexts({
    company: DevelopersCompanyContext,
    viewer: ViewerContext,
  }),
  hot,
)(CompaniesDocs);
